
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Comments`}</h1>
<p>{`Only use `}<inlineCode parentName="p">{`/** ... */`}</inlineCode>{` for documentation comments.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
// This function does something
// pretty cool and that we need
// in every system
function foo() {
  return 'bar';
}

function foo() {
  /**
    * We use bar here because it's 
    * much better than baz
    */
  return 'bar';
}

// Good
/**
  * This function does something
  * pretty cool and that we need
  * in every system
  */
function foo() {
  return 'bar';
}

function foo() {
  // We use bar here because it's 
  // much better than baz
  return 'bar';
}
`}</code></pre>
<h5><strong parentName="h5">{`NOTE`}</strong>{`: Notice the double asterisk `}<inlineCode parentName="h5">{`**`}</inlineCode>{` in the first line.`}</h5>
<p>{`Always favor placing the comment in the same line they're explaining.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? Because that way they don't disrupt the flow of the code with an extra line.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
function foo() {
  // if selected we return a 'bar'
  if (type === 'selected') {
    return 'bar';
  }
  
  return 'baz';
}

// Good
function foo() {
  if (type === 'selected') {  // if selected we return a 'bar'
    return 'bar';
  }
  
  return 'baz';
}
`}</code></pre>
<p>{`If the comment is too long and wouldn't fit in the same line, move it to the line above.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? Because in that case, the disruption in the code flow is bigger adding empty lines than comment lines. Also, easier to maintain.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
function foo() {
  if (type === 'selected') {  // this is a really long
                              // comment that wouldn't have
                              // fit in a single line
                              // so we wrap it in multiple ones
    return 'bar';
  }
  
  return 'baz';
}

// Good
function foo() {
  // this is a really long
  // comment that wouldn't have
  // fit in a single line
  // so we wrap it in multiple ones
  if (type === 'selected') {
    return 'bar';
  }
  
  return 'baz';
}
`}</code></pre>
<p>{`Always leave two spaces between the end of the line of code and the comment for inline comments.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
function foo() {
  if (type === 'selected') {// if selected we return a 'bar'
    return 'bar';
  }
  return 'baz';
}

// Good
function foo() {
  if (type === 'selected') {  // if selected we return a 'bar'
    return 'bar';
  }
  return 'baz';
}
`}</code></pre>
<p>{`Always start comments with a space.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
//this is a comment
/**
  *this is a
  *multiline comment
  */

// Good
// this is a comment
/**
  * this is a 
  * multiline comment
  */
`}</code></pre>
<p>{`Use `}<inlineCode parentName="p">{`// TODO:`}</inlineCode>{` comments to help other developers (and your future self) that something still needs more work.`}</p>
<pre><code parentName="pre" {...{}}>{`function foo() {
  return 'bar';  // TODO: Return baz here instead
}
`}</code></pre>
<p>{`Never use any other kind of meta comments: `}<inlineCode parentName="p">{`// FIXME:`}</inlineCode>{`, `}<inlineCode parentName="p">{`// NOTE:`}</inlineCode>{`, etc.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? Because they're not standard and other developers might not be aware of their existence rendering them useless since they cannot be easily searched for. Basically, a `}<inlineCode parentName="p">{`FIXME`}</inlineCode>{` is like a `}<inlineCode parentName="p">{`TODO`}</inlineCode>{` and a `}<inlineCode parentName="p">{`NOTE`}</inlineCode>{` is like normal comment would be enough.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
function foo() {
  return 'bar';  // FIXME: Return baz here instead
}

function foo() {
  return 'bar';  // NOTE: We return bar here instead of baz
}

// Good
function foo() {
  return 'bar';  // TODO: Return baz here instead
}

function foo() {
  return 'bar';  // We return bar here instead of baz
}
`}</code></pre>
<p>{`Never leave commented out code.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? It's confusing for anyone else and even for your future self. What's the purpose of that code? It's an example implementation? It's something to be done in the future? Something that used to be done in the past? Can I delete it? Should I restore it? All of those are questions strangers to that code might want to ask themselves.`}</p>
</blockquote>
<p>{`If you want to keep a history of the code ⇒ That's what git is for.`}</p>
<p>{`If you want to keep an useful piece of code for the future ⇒ Share it as a recipe.`}</p>
<p>{`If it's something you need to do in the future ⇒ Label it with an explicit TODO comment and explain what needs to be done.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
function foo() {
  // const bar = 'baz';
  const baz = 'bar';

  // ... more code ...
}

// Good
function foo() {
  const baz = 'bar';

  // ... more code ...
}
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;